
import VerifyCode from '@/components/VerifyCode/index.vue'
import QueryForm from '@/components/QueryForm/index.vue'
import Pagination from "@/components/Pagination/index.vue";
import DataTableColumn from "@/components/DataTable/DataTableColumn/index.vue";

export default
  {
    install(Vue) {
      // 表单内发送验证码item组件
      Vue.component('verify-code', VerifyCode)
      //分页组件
      Vue.component('pagination', Pagination)
      //查询表单组件
      Vue.component('query-form', QueryForm)
       // 数据表格列
       Vue.component('data-table-column', DataTableColumn)
    }
  }



// WEBPACK FOOTER //
// ./src/components/index.js